// DEPENDENCIES ---------------------------------------------------------------- //

import { FlowStep } from '@features/moves/components/FlowVisualization';

// TYPES ---------------------------------------------------------------- //

interface ConfirmationFlowObject {
  pickup?: FlowStep[];
  delivery?: FlowStep[];
}

// UTILITY ---------------------------------------------------------------- //

/**
 * Parses the confirmation flow from a confirmationset
 * Handles both array format (legacy) and object format (current)
 */
export const parseConfirmationFlow = (
  confirmationset: { confirmation_flow?: unknown } | null | undefined,
  confirmationType: 'pickup' | 'delivery'
): FlowStep[] => {
  if (!confirmationset?.confirmation_flow) {
    return [];
  }

  let flow = confirmationset.confirmation_flow;

  // Handle string JSON (in case GraphQL returns it as a string)
  if (typeof flow === 'string') {
    try {
      flow = JSON.parse(flow);
    } catch (e) {
      return [];
    }
  }

  const flowTyped = flow as FlowStep[] | ConfirmationFlowObject;

  if (flowTyped && typeof flowTyped === 'object' && !Array.isArray(flowTyped)) {
    const flowObj = flowTyped as ConfirmationFlowObject;
    const typeFlow = flowObj[confirmationType];

    if (!typeFlow || !Array.isArray(typeFlow)) {
      // If the type-specific flow doesn't exist, try the other type as fallback
      const otherType = confirmationType === 'pickup' ? 'delivery' : 'pickup';
      const otherTypeFlow = flowObj[otherType];
      if (otherTypeFlow && Array.isArray(otherTypeFlow)) {
        return [...otherTypeFlow].sort((a, b) => (a.ordinality || 0) - (b.ordinality || 0));
      }
      return [];
    }
    return [...typeFlow].sort((a, b) => (a.ordinality || 0) - (b.ordinality || 0));
  }

  // Handle array format (legacy)
  if (Array.isArray(flowTyped)) {
    return [...flowTyped].sort((a, b) => (a.ordinality || 0) - (b.ordinality || 0));
  }

  return [];
};

